/* Quick Start page — protocol switcher.
   Progressive enhancement: without JS, every protocol detail is visible and the
   selector cards / pills are in-page anchors (#protocol-<slug>). With JS, only
   the selected protocol shows; cards + sticky pills switch it; the URL hash
   deep-links a protocol (Klaviyo lands a customer on theirs). */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.qsInit) return;
    root.dataset.qsInit = '1';
    root.classList.add('qs-page--js');

    var details = Array.prototype.slice.call(root.querySelectorAll('.qs-detail'));
    if (!details.length) return;
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-qs-select]'));

    function slugFromHash() {
      var m = (window.location.hash || '').match(/^#protocol-(.+)$/);
      return m ? m[1] : null;
    }
    function findDetail(slug) {
      for (var i = 0; i < details.length; i++) {
        if (details[i].dataset.slug === slug) return details[i];
      }
      return null;
    }
    function setActive(slug) {
      details.forEach(function (d) {
        d.classList.toggle('is-active', d.dataset.slug === slug);
      });
      triggers.forEach(function (t) {
        var on = t.dataset.qsSelect === slug;
        t.classList.toggle('is-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); }
        else { t.removeAttribute('aria-current'); }
      });
    }
    function scrollToDetail(detail) {
      var headerOffset = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-offset'), 10
      ) || 58;
      var pills = root.querySelector('.qs-pills');
      var pillsH = (pills && window.getComputedStyle(pills).display !== 'none') ? pills.offsetHeight : 0;
      var y = detail.getBoundingClientRect().top + window.pageYOffset - headerOffset - pillsH - 12;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    function select(slug, opts) {
      opts = opts || {};
      var detail = findDetail(slug);
      if (!detail) return false;
      setActive(slug);
      if (opts.updateHash) {
        try { history.replaceState(null, '', '#protocol-' + slug); } catch (e) { /* no-op */ }
      }
      if (opts.scroll) scrollToDetail(detail);
      return true;
    }

    // Initial state: deep-link hash wins (incl. drafts), else the first
    // non-draft protocol (so a gated draft never leads the page).
    var hashSlug = slugFromHash();
    var firstNonDraft = (details.filter(function (d) { return d.dataset.draft !== 'true'; })[0] || details[0]).dataset.slug;
    var initial = (hashSlug && findDetail(hashSlug)) ? hashSlug : firstNonDraft;
    select(initial, { scroll: false });
    // Deep-link (e.g. a Klaviyo email) lands the customer on their protocol.
    if (hashSlug && findDetail(hashSlug)) {
      requestAnimationFrame(function () { scrollToDetail(findDetail(initial)); });
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        var slug = t.dataset.qsSelect;
        if (!findDetail(slug)) return; // fall back to native anchor behaviour
        e.preventDefault();
        // Selector cards smooth-scroll down to the detail (all screens);
        // the sticky pills are an in-place quick-switcher, so they don't jump.
        var isCard = t.classList.contains('qs-card');
        select(slug, { updateHash: true, scroll: isCard });
        var heading = findDetail(slug).querySelector('.qs-detail__name');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      });
    });

    window.addEventListener('hashchange', function () {
      var slug = slugFromHash();
      if (slug && findDetail(slug)) select(slug, { scroll: true });
    });
  }

  function boot() {
    document.querySelectorAll('.qs-page').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when re-added in the theme editor.
  document.addEventListener('shopify:section:load', boot);
})();
